import { Component, OnInit , Input} from '@angular/core';
import { Currencyformatters, ICurrencyFormatter } from '../../../interfaces/ICurrencyFormatters';

@Component({
  selector: 'currencyInput',
  template: require('./currencyInput.component.html'),
  styles: [require('./currencyInput.component.scss')]
})
export class CurrencyInputComponent implements OnInit {

  @Input() public formatterEnabled: string = "false";
  @Input() public inputValue: number = 0;
  @Input() public currency: string = "USD";

  public formatters:ICurrencyFormatter = Currencyformatters;

  constructor() {}

  ngOnInit() {}


  get formattedInputValue()
  {
   // return this.formatterEnabled;
    if(this.formatterEnabled=="true")
    {
      return this.formatters[this.currency].format(this.inputValue);
    }

    return this.inputValue;
  }
  

}

